import React from 'react';
import 'static/styles/main.scss'; 
export default function Layout(props) {
    return (
        <React.Fragment>
            {props.children} 
        </React.Fragment>
    )
}